import { render } from "./safari.vue?vue&type=template&id=29094a8e"
import script from "./safari.vue?vue&type=script&lang=js"
export * from "./safari.vue?vue&type=script&lang=js"

import "./safari.vue?vue&type=style&index=0&id=29094a8e&lang=less"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__